import { showLightbox } from './lightbox';

const getYoutubeVideoId = url => {
  console.log("getYoutubeVideoId");
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);


  if (match && match[2].length === 11) { 
    return match[2];
  }
  return 'error'; 
};

const showVideoLightbox = url => {
    var videoId = getYoutubeVideoId(url);
    var embedLink = "https://www.youtube.com/embed/" + videoId;
   // console.log("showVideoLightbox" + embedLink);
  showLightbox(null, 'lightboxVideo', { url: embedLink }); 
};

export default () => {
    //console.log("video default");
  $('a.lightboxVideo').click(function handleClickVideo(e) {
    e.preventDefault();
    showVideoLightbox(this.href);
  });

  $('div.lightboxVideo').click(function handleClickVideo(e) {
    
    e.preventDefault();
    showVideoLightbox(this.attributes[1].nodeValue);
  });
};
